<template>

  <!-- app-layer {admin} -->
  <div class="app-layer admin" @click="layerClick($event)">

    <transition name="right-modal" v-show="show">

      <div class="modal-custom right" name="add-media" v-if="show" :class="{loading: loading}">

        <span class="close" @click="closeModal()">chiudi</span>

        <h2 class="mt-0">Aggiungi nuovo media</h2>

        <p>Peso massimo dei file: <b>4MB</b><br>
        </p>

        <v-upload v-model="files" :multiple="true" />

        <div class="files-preview">

          <ul v-if="files && files.length > 0" class="file-list">

            <li v-for="file in files" :key="file.lastModified">

              <span class="file_name">{{file.name}}</span>

            </li>

          </ul>

          <p v-else class="empty">Nessun file ancora inserito...</p>

        </div>

        <button @click="uploadFiles($event)"
          class="belt-btn animated"
          :class="{v_loading: uploading}"
          :disabled="!files || files.length == 0">carica file</button>

      </div>

    </transition>

  </div>

</template>

<script>
export default{

  props: [],

  data: function(){

    return {

      loading: false,
      show: false,
      // ... modal data
      files: null,
      uploading: false,
      uploaded: [],
      errors: 0

    }

  },

  methods: {

    layerClick: function(event){

      if( event.target.classList.contains('app-layer') ) this.closeModal();

    },

    // manage close animation
    closeModal: function(){

      this.show = false;
      setTimeout(function(vue){
        vue.$destroy();
      }, 400, this);

    },

    loadFiles: function(){

     // console.log( this.$refs.files.files )
      this.files = this.$refs.files.files;

    },

    uploadFiles: async function(event){

      var vue = this;
      vue.uploading = true;

      _.forEach(vue.files, file => {

        let formData = new FormData();
        formData.append('file', file);

        axios_form_data.post(window.location.origin + '/data/media/upload', formData)
        .then(res => {

          // vue.uploaded.push( res.data.media );
          vue.$parent.media_list.unshift(res.data.media);
          console.log(res.data.media);

        })
        .catch(err => {

          console.log(err);
          vue.$store.commit('add_message', {
            type: 'error',
            message: 'Si è verificato un errore con il file' + file.name
          });
          vue.errors++;


        })

      }) // foreach

      // this.addParentMedia()

    },

    addParentMedia: function(){

      var vue = this;

      if( this.uploaded.length > 0 ){
        _.forEach( this.uploaded, file => {
         // console.log(file);
          vue.$parent.media_list.unshift(file);
        });
      }

      this.resetUpload();

    },

    resetUpload: function(){

      this.uploading = false;
      this.files = [];
      this.uploaded = [];

      // show message and close modal
      if( this.errors == 0 ){

        this.$store.commit('add_message', {
          type: 'success',
          message: 'Upload dei file concluso'
        })

        this.closeModal();

      }
      this.errors = 0;

    }

  },

  mounted: function(){

    // show component
    this.show = true;

  },

  // send modal destry to other components
  destroyed: function(){

    this.$parent.add_media = false;

  }

}
</script>

<style scoped>
.modal-custom{
  max-width: 700px;
  background-color: white;
}
ul.file-list{
  list-style-type: none;
  padding: 0;
  margin: 1em 0;
}
</style>
